(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;

  function openDrawer() {
    if (!drawer.hidden) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var first = drawer.querySelector('[data-cart-close]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function updateCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.querySelector('.header__cart');
        var badge = document.querySelector('.header__cart-count');
        if (!link) return;
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            link.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      })
      .catch(function () {});
  }

  function refresh() {
    return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer]');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      })
      .then(updateCount)
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      })
      .then(refresh)
      .then(openDrawer)
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.header__cart');
    if (cartLink) {
      e.preventDefault();
      refresh().then(openDrawer);
    }
  });

  drawer.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      drawer.classList.add('is-busy');
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: parseInt(qtyBtn.getAttribute('data-cart-index'), 10),
          quantity: parseInt(qtyBtn.getAttribute('data-cart-qty'), 10)
        })
      })
        .then(refresh)
        .catch(function () {})
        .then(function () { drawer.classList.remove('is-busy'); });
      return;
    }
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeroSlides(scope) {
    (scope || document).querySelectorAll('[data-hero-slideshow]').forEach(function (show) {
      if (show.dataset.hsInit) return;
      var slides = show.querySelectorAll('.hero__slide');
      if (slides.length < 2) return;
      show.dataset.hsInit = '1';
      var interval = parseInt(show.getAttribute('data-interval'), 10);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0;
      var timer = null;
      function go(n) {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      var wrap = show.closest('.hero__product') || show.parentNode;
      var prev = wrap.querySelector('[data-hero-prev]');
      var next = wrap.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', function () { stop(); go(i - 1); });
      if (next) next.addEventListener('click', function () { stop(); go(i + 1); });
      if (interval && !reduce) timer = setInterval(function () { go(i + 1); }, interval);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeroSlides(); });
  } else {
    initHeroSlides();
  }
  document.addEventListener('shopify:section:load', function (e) { initHeroSlides(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var step = e.target.closest('[data-pdp-step]');
  var thumb = e.target.closest('[data-pdp-thumb]');
  if (!step && !thumb) return;
  var scope = (step || thumb).closest('.pdp');
  if (!scope) return;
  var thumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-pdp-thumb]'));
  if (step) {
    var current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    var next = (current + parseInt(step.getAttribute('data-pdp-step'), 10) + thumbs.length) % thumbs.length;
    thumb = thumbs[next];
    thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  var id = thumb.getAttribute('data-pdp-thumb');
  thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  scope.querySelectorAll('.pdp__slide').forEach(function (slide) {
    slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === id);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-popup]');
  if (!root) return;

  var KEY = 'rr-popup-dismissed';
  var card = root.querySelector('.popup__card');
  var inEditor = window.Shopify && window.Shopify.designMode;
  var lastFocus = null;

  function suppressed() {
    try {
      var until = parseInt(localStorage.getItem(KEY) || '0', 10);
      return until > Date.now();
    } catch (e) { return false; }
  }

  function suppress() {
    var days = parseInt(root.getAttribute('data-popup-frequency') || '14', 10);
    try { localStorage.setItem(KEY, String(Date.now() + days * 86400000)); } catch (e) {}
  }

  function open() {
    if (!root.hidden) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var field = root.querySelector('[data-popup-input]');
    if (field) { try { field.focus({ preventScroll: true }); } catch (e) {} }
  }

  function close() {
    root.classList.remove('is-open');
    root.hidden = true;
    document.documentElement.style.overflow = '';
    suppress();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-popup-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  var copyBtn = root.querySelector('[data-popup-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = root.querySelector('[data-popup-code]');
      if (!code || !navigator.clipboard) return;
      navigator.clipboard.writeText(code.textContent.trim()).then(function () {
        var original = copyBtn.textContent;
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = original; }, 1800);
      });
    });
  }

  if (document.querySelector('[data-popup-autoopen]')) {
    suppress();
    open();
    return;
  }

  if (inEditor) {
    document.addEventListener('shopify:section:select', function (e) {
      if (root.closest('.shopify-section') === e.target) open();
    });
    document.addEventListener('shopify:section:deselect', function () { root.classList.remove('is-open'); root.hidden = true; document.documentElement.style.overflow = ''; });
    return;
  }

  if (suppressed()) return;
  var wait = parseInt(root.getAttribute('data-popup-delay') || '5', 10) * 1000;
  setTimeout(open, wait);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-how"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var tab = e.target.closest('[data-rr-tab]');
  if (tab) {
    var root = tab.closest('[data-rr-tabs]');
    root.querySelectorAll('[data-rr-tab]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = !on;
        if (!on) {
          panel.querySelectorAll('video').forEach(function (v) { v.pause(); });
          panel.querySelectorAll('.is-playing').forEach(function (f) { f.classList.remove('is-playing'); });
        }
      }
    });
    return;
  }
  var player = e.target.closest('[data-rr-player]');
  if (!player) return;
  var video = player.querySelector('video');
  if (!video) return;
  if (video.paused) {
    video.play();
    player.classList.add('is-playing');
  } else {
    video.pause();
    player.classList.remove('is-playing');
  }
});
document.addEventListener('shopify:block:select', function (e) {
  var tab = e.target.closest && e.target.closest('[data-rr-tab]');
  if (tab) tab.click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-buy"]) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-sticky-buy]');
  if (!bar) return;

  var anchor = document.querySelector('.hero__buy, .hero__ctas');
  var visible = false;

  function show() {
    if (visible) return;
    visible = true;
    bar.hidden = false;
    requestAnimationFrame(function () { bar.classList.add('is-visible'); });
  }

  function hide() {
    if (!visible) return;
    visible = false;
    bar.classList.remove('is-visible');
  }

  if (anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) { show(); } else { hide(); }
      });
    }, { threshold: 0 });
    io.observe(anchor);
  } else {
    var onScroll = function () {
      if (window.scrollY > 520) { show(); } else { hide(); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-two-angles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var tab = e.target.closest('[data-why-tab]');
  if (!tab) return;
  var scope = tab.getAttribute('data-section-scope');
  var index = tab.getAttribute('data-why-tab');
  document.querySelectorAll('[data-section-scope="' + scope + '"]').forEach(function (el) {
    if (el.hasAttribute('data-why-tab')) {
      var active = el.getAttribute('data-why-tab') === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    }
    if (el.hasAttribute('data-why-panel')) {
      var show = el.getAttribute('data-why-panel') === index;
      el.classList.toggle('is-active', show);
      if (show) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
